/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetGroupedRecommendationsDto
 */
export interface GetGroupedRecommendationsDto {
    /**
     * 
     * @type {string}
     * @memberof GetGroupedRecommendationsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetGroupedRecommendationsDto
     */
    profileName: string;
    /**
     * 
     * @type {string}
     * @memberof GetGroupedRecommendationsDto
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof GetGroupedRecommendationsDto
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetGroupedRecommendationsDto
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetGroupedRecommendationsDto
     */
    scopeType: GetGroupedRecommendationsDtoScopeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetGroupedRecommendationsDto
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof GetGroupedRecommendationsDto
     */
    description: string;
}


/**
 * @export
 */
export const GetGroupedRecommendationsDtoScopeTypeEnum = {
    Global: 'Global',
    Company: 'Company',
    Purchaser: 'Purchaser'
} as const;
export type GetGroupedRecommendationsDtoScopeTypeEnum = typeof GetGroupedRecommendationsDtoScopeTypeEnum[keyof typeof GetGroupedRecommendationsDtoScopeTypeEnum];


/**
 * Check if a given object implements the GetGroupedRecommendationsDto interface.
 */
export function instanceOfGetGroupedRecommendationsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "profileName" in value;
    isInstance = isInstance && "profileId" in value;
    isInstance = isInstance && "scopeType" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function GetGroupedRecommendationsDtoFromJSON(json: any): GetGroupedRecommendationsDto {
    return GetGroupedRecommendationsDtoFromJSONTyped(json, false);
}

export function GetGroupedRecommendationsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGroupedRecommendationsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'profileName': json['profileName'],
        'profileId': json['profileId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'scopeType': json['scopeType'],
        'count': json['count'],
        'description': json['description'],
    };
}

export function GetGroupedRecommendationsDtoToJSON(value?: GetGroupedRecommendationsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'profileName': value.profileName,
        'profileId': value.profileId,
        'companyId': value.companyId,
        'clientId': value.clientId,
        'scopeType': value.scopeType,
        'count': value.count,
        'description': value.description,
    };
}

